module.exports = __webpack_public_path__ + "media/images/city_img/t_2-014078eaf4e6610f8092b2871a5775b7.png";